import React, { Component } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import Col from "react-bootstrap/lib/Col";
import { func } from "prop-types";

import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import MainContainer from "pages/_components/MainContainer";
import I18n from "pages/_components/I18n";
import { Mixpanel } from "util/clickstreaming";

class InvitationCodeSendFail extends Component {
    static propTypes = {
        dispatch: func.isRequired,
    };

    handleClick = () => {
        const { dispatch } = this.props;
        Mixpanel.track("onboarding.invitation.fail");
        dispatch(push("/enrollment/requestInvitationCode"));
    };

    render() {
        return (
            <MainContainer className="main-container onboarding-layout">
                <Container>
                    <Col xs={12} md={8} mdOffset={2}>
                        <I18n
                            component="h2"
                            componentProps={{ className: "title-content text-center" }}
                            id="onboarding.invitation.send.fail.title"
                        />

                        <I18n
                            component="p"
                            componentProps={{ className: "text-center mt-8" }}
                            id="onboarding.invitation.send.fail.content"
                        />

                        <Button
                            bsStyle="primary"
                            onClick={this.handleClick}
                            label="onboarding.invitation.send.fail.button"
                            block
                        />
                    </Col>
                </Container>
                {/* <Container className="flex-grow items-center container--layout"></Container> */}
            </MainContainer>
        );
    }
}

export default connect()(InvitationCodeSendFail);
